import React, { useState } from "react";
import axios from "axios";
import { ArrowRight, Check } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = ({ t, lang }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error(t.newsletter.error);
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email, locale: lang });
      setDone(true);
      toast.success(t.newsletter.success);
      setEmail("");
    } catch (err) {
      toast.error(t.newsletter.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="newsletter"
      data-testid="newsletter-section"
      className="px-6 md:px-12 lg:px-16 py-24 md:py-32 bg-[#1C1A18]"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6">
          <p className="overline mb-5">{t.newsletter.overline}</p>
          <h2 className="font-serif font-light text-[#F3EFE9] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            {t.newsletter.title_l1}
            <br />
            <span className="italic text-[#A67A53]">{t.newsletter.title_l2}</span>
          </h2>
          <p className="mt-8 text-[#9D9287] text-base md:text-lg max-w-md font-light leading-relaxed">
            {t.newsletter.sub}
          </p>
        </div>

        <div className="lg:col-span-6">
          <form
            data-testid="newsletter-form"
            onSubmit={onSubmit}
            className="flex items-end gap-4 max-w-xl"
          >
            <div className="flex-1">
              <label
                htmlFor="newsletter-email"
                className="overline block mb-3"
              >
                Email
              </label>
              <input
                id="newsletter-email"
                data-testid="newsletter-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.newsletter.placeholder}
                className="input-line"
              />
            </div>
            <button
              type="submit"
              data-testid="newsletter-submit-btn"
              disabled={loading}
              className="btn-primary disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {done ? <Check size={14} /> : t.newsletter.submit}
              {!done && <ArrowRight size={14} strokeWidth={1.5} />}
            </button>
          </form>
          {done && (
            <p
              data-testid="newsletter-success"
              className="overline mt-6 text-[#A67A53]"
            >
              ✦ {t.newsletter.success}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};
